import { createContext, PropsWithChildren, useContext, useMemo } from "react";
import { useParams } from "react-router";

type StorefrontViewContextValues = {
  storefrontId: string | null;
  isOrgNested: boolean;
  /** Absolute path prefix for storefront routes, e.g. "/app/storefront/123" or "/app/organization/456/storefront/123" */
  basePath: string;
};

const StorefrontViewContext = createContext<StorefrontViewContextValues>({
  storefrontId: null,
  isOrgNested: false,
  basePath: "",
});

export const StorefrontViewProvider = ({ children }: PropsWithChildren) => {
  const { storefrontId, organizationId } = useParams();

  const value = useMemo(
    () => ({
      storefrontId: storefrontId ?? null,
      isOrgNested: !!organizationId,
      basePath: organizationId
        ? `/app/organization/${organizationId}/storefront/${storefrontId}`
        : `/app/storefront/${storefrontId}`,
    }),
    [storefrontId, organizationId],
  );

  return (
    <StorefrontViewContext.Provider value={value}>
      {children}
    </StorefrontViewContext.Provider>
  );
};

export const useStorefrontView = () => useContext(StorefrontViewContext);
